import { AdjustedTime } from "model/Match/AdjustedTime";
import {
  TimeAttackRoundWeighting,
  getTimeAttackRoundTimesWithWeighting,
} from "./TimeAttackRoundWeighting";
import { TimeAttackScoring, TimeAttackScoringBase } from "./TimeAttackScoring";

const getTotalWeighting = (scoring: TimeAttackScoringAverage) => {
  return scoring.roundWeightings
    .flatMap((r) => r.weightings)
    .reduce((a, b) => a + b, 0);
};
export type TimeAttackScoringAverage = TimeAttackScoringBase & {
  type: "Average";
  asPercentage: boolean;
  roundWeightings: TimeAttackRoundWeighting[];
};

export const isTimeAttackScoringAverage = (
  scoring: TimeAttackScoring
): scoring is TimeAttackScoringAverage => {
  return scoring.type === "Average";
};

export const getTimeAttackAverageScore = (
  times: (AdjustedTime | undefined)[],
  scoring: TimeAttackScoringAverage
): number => {
  const timesWithWeighting = scoring.roundWeightings.map((roundWeighting) =>
    getTimeAttackRoundTimesWithWeighting(times, roundWeighting)
  );

  const totalWeighting = getTotalWeighting(scoring);
  if (totalWeighting <= 0) {
    return 0;
  }

  const score = timesWithWeighting
    .map((times) =>
      times.reduce(
        (a, b) =>
          a +
          (!!b.roundTime
            ? (b.roundTime.time * b.weighting) / totalWeighting
            : 0),
        0
      )
    )
    .reduce((a, b) => a + b, 0);

  return roundScore(score);
};

const roundScore = (score: number) => {
  return Math.round((score + Number.EPSILON) * 1) / 1;
};
